import { BotProvider } from '@/contexts/bot'
import { namespacesLoader } from '@/i18n/route-namespaces'
import { BotLayout } from '@/layouts'

import { BotDefaultRedirect } from './bot-default-redirect'
import { bubbleRoutes } from './bubble-routes'
import { builderRoutes } from './builder-routes'
import { campaignModuleRoutes } from './campaign-module-routes'
import { campaignRoutes } from './campaign-routes'
import { conversationHistoryRoutes } from './conversation-history-routes'
import { dashboardsRoutes } from './dashboards-routes'
import { finnRoutes } from './finn-routes'
import { followUpRoutes } from './follow-up-routes'
import { knowledgeBaseRoutes } from './knowledge-base-routes'
import { membersRoutes } from './members-routes'
import { n8nRoutes } from './n8n-routes'
import { settingsRoutes } from './settings-routes'

export const botRoutes = {
  path: 'bots/:botId',
  loader: namespacesLoader(['bots', 'dashboards', 'botMigration']),
  element: (
    <BotProvider>
      <BotLayout />
    </BotProvider>
  ),
  children: [
    {
      index: true,
      element: <BotDefaultRedirect />,
    },
    builderRoutes,
    campaignModuleRoutes,
    campaignRoutes,
    dashboardsRoutes,
    membersRoutes,
    conversationHistoryRoutes,
    knowledgeBaseRoutes,
    followUpRoutes,
    settingsRoutes,
    bubbleRoutes,
    n8nRoutes,
    finnRoutes,
  ],
}
